import ImageView from "~components/ImageView/ImageView.tsx";
import { ImageSizes } from "~enums/imageSizes.ts";
import type { ImageTypes } from "~enums/imageTypes.ts";
import type { Image } from "~types/image.ts";
import { findImageByTypes } from "~utilities/findImageByTypes.ts";

type Props = {
  images: Image[];
  imageTypes: ImageTypes[];
};

export const DataTableImageColumn = ({ images, imageTypes }: Props) => {
  const image = findImageByTypes(images, imageTypes);
  return <ImageView imageType={image?.imageType || imageTypes[0]} imageUrl={image?.url} size={ImageSizes.Small} width={25} height={25} />;
};
